import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `length` property of an object.
export default shallowProperty('length');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/_getLength.js
// module id = 14
// module chunks = 0 1